export function openOCI(url) {
  const target = String(url || "").trim();
  if (!target) return false;
  window.open(target, "_self");
  return true;
}

export default openOCI;
